import {
    Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import store from '@/state/store';
import Payload from '@/state/modules/payload';
import { sendGet } from '@/api-client/api';
import { adsAPI } from '@samclick-static-urls';

class MediaLandingPageState {
    public loading: boolean = false

    public landingPages: object[] = []
}

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: 'media_landingpage',
})
class MediaLandingPageStore extends VuexModule {
    mediaLandingPageStore: MediaLandingPageState = new MediaLandingPageState();

  @Mutation
    SET_MEDIA_LANDING_PAGE_LOADING(loading: boolean) {
        this.mediaLandingPageStore.loading = loading;
    }

  @Mutation
  SET_MEDIA_LANDING_PAGE_LIST(response: object[]) {
      this.mediaLandingPageStore.landingPages = response || [];
  }

  @Action({ rawError: true })
  showLoader(show: boolean) {
      this.context.commit('SET_MEDIA_LANDING_PAGE_LOADING', show);
  }

  @Action({ rawError: true })
  getMediaLandingPageList(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(adsAPI.getLandingPages, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_MEDIA_LANDING_PAGE_LIST', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }
}

export default getModule(MediaLandingPageStore);
